module.exports = __webpack_public_path__ + "img/home1_md.552fd3f6.png";